// =============================================
// API helpers para el formulario público de leads.
// Lectura de config vía vista RLS-pública + llamadas a Edge Functions.
// =============================================

import { supabase } from "./supabase";

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
];

export async function fetchPublicForm(slug) {
  const { data, error } = await supabase
    .from("lead_capture_forms_public")
    .select("*")
    .eq("slug", slug)
    .maybeSingle();

  if (error) throw new Error(error.message);
  return data;
}

export function getUtmsFromUrl(search) {
  const params = new URLSearchParams(search);
  const utm = {};
  for (const k of UTM_KEYS) {
    const v = params.get(k);
    if (v) utm[k] = v;
  }
  return utm;
}

async function callEdge(path, payload) {
  const res = await fetch(`${SUPABASE_URL}/functions/v1/${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      apikey: SUPABASE_ANON_KEY,
    },
    body: JSON.stringify(payload),
  });
  return res;
}

export async function submitPublicLead(payload) {
  const res = await callEdge("submit-public-lead", payload);
  let body = null;
  try {
    body = await res.json();
  } catch {
    body = null;
  }
  return { ok: res.ok && body?.ok === true, status: res.status, body };
}

export async function trackPublicView(slug) {
  try {
    await callEdge("track-lead-view", { slug });
  } catch {
    // Silencioso: no bloqueamos al usuario por un fallo de tracking.
  }
}
